/** Leaflet'ni CDN'dan runtime'da yuklash (umumiy).
 * npm dependency EMAS — CI yarn.lock'ini o'zgartirmaslik uchun. */

const LEAFLET_JS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js'
const LEAFLET_CSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css'

export const SATELLITE_URL = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'

let leafletPromise = null

export function loadLeaflet() {
    if (window.L) return Promise.resolve(window.L)
    if (leafletPromise) return leafletPromise
    leafletPromise = new Promise((resolve, reject) => {
        const css = document.createElement('link')
        css.rel = 'stylesheet'
        css.href = LEAFLET_CSS
        document.head.appendChild(css)

        const script = document.createElement('script')
        script.src = LEAFLET_JS
        script.onload = () => resolve(window.L)
        script.onerror = () => { leafletPromise = null; reject(new Error('leaflet cdn')) }
        document.head.appendChild(script)
    })
    return leafletPromise
}
